// Shubham code
import React, { useEffect, useState } from "react";
import HRNavbar from "../../../HR/HRNavbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  useMediaQuery,
  CircularProgress,
  TextField,
  Button,
  AppBar,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TablePagination,
  Tooltip,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ViewPayoutDetailsmodal from "./ViewPayoutDetailsmodal";
import Footer from "../../../../Footer";
import { GridCheckCircleIcon, GridCloseIcon } from "@mui/x-data-grid";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { API_URL } from "../../../Config/api";
const customStyles = {
  "& .Mui-focused": {
    outline: "none",
  },
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  pt: 2,
  px: 4,
  pb: 3,
};
const OngoingServiceCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "3rem",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    borderLeft: "4px solid #A5D6A7",
    borderRight: "4px solid #A5D6A7",
  },
});

const filterBoxStyle = {
  p: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: 200,
  height: "2.5rem",
  backgroundColor: "#ffffff",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  borderRadius: "10px",
  border: "1px solid #C9C9C9",
};

const ProcessPayout = () => {
  const accessToken = localStorage.getItem("token");

  const [isSmallScreen, setIsSmallScreen] = useState(false); // Mock for screen size
  const [loading, setLoading] = useState(false);
  const [onServices, setOnServices] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableHeight, setTableHeight] = useState("auto");

  const [eventID, setEventID] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedService, setSelectedService] = useState("");

  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [professionalList, setProfessionalList] = useState([]);
  const [selectedProfessional, setSelectedProfessional] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  // success | error | warning | info

  console.log("eventID", eventID);

  const filteredData = onServices.filter((item) => {
    // future search / date filter logic
    return true;
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // ************** API Integration **********************************************

  useEffect(() => {
    // Set screen size state dynamically
    const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API_URL}/pay_out/service_get/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`, // if required
          },
        });

        setServiceList(response.data); // set dropdown options

        setLoading(false);
      } catch (err) {
        console.error("Error fetching services:", err);

        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  // *****************************************************************************

  const handleSubmit = async () => {
    if (!fromDate || !toDate || !selectedService) {
      setSnackbarMsg("Please fill all required fields");
      setSnackbarType("warning");
      setSnackbarOpen(true);
      return;
    }

    try {
      setLoading(true);

      const serviceValue = selectedService === "All" ? "" : selectedService;

      const response = await axios.get(`${API_URL}/pay_out/process_payout/`, {
        params: {
          from_date: fromDate,
          to_date: toDate,
          service_title: serviceValue,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setOnServices(response.data);
      setIsFiltered(true);
      setPage(0);
    } catch (error) {
      setSnackbarMsg("Failed to fetch process payout data");
      setSnackbarType("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setSelectedService("");
    setSelectedProfessional("");
    setOnServices([]);
    setIsFiltered(false);

    setSnackbarMsg("Filters reset successfully");
    setSnackbarType("info");
    setSnackbarOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const setDynamicHeight = () => {
      const screenHeight = window.innerHeight;
      var tableContainerHeight =
        screenHeight - setTableHeight(tableContainerHeight + "px");
    };
    setDynamicHeight();
    window.addEventListener("resize", setDynamicHeight);
    return () => {
      window.removeEventListener("resize", setDynamicHeight);
    };
  }, []);

  const handleView = (row) => {
    const payload = {
      ...row,
      start_date: fromDate,
      end_date: toDate,
      srv_prof_id: row.srv_prof_id,

      is_bank_verified: row.bank_verification,
    };

    setSelectedRow(payload);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    handleSubmit(); // Refresh data when modal closes
    setOpenViewModal(false);
    setSelectedRow(null);
  };
  return (
    <>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, mt: 14.6, ml: 1, mr: 1, mb: 3 }}>
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={1}
          alignItems={isSmallScreen ? "center" : "flex-start"}
          sx={{ pt: 1 }}
        >
           <Typography
                     variant="h6"
                     sx={{ fontWeight: 700, color: "#205964", mr: 2 }}
                   >
                      Process Payout
                   </Typography>
         

          {/* Start Date */}
          <Box sx={{ ...filterBoxStyle, ml: "2rem" }}>
              <Typography variant="caption" sx={{ mr: 1, color: "gray" }}>
                          From:
                        </Typography>
            <InputBase
              label="Start Date"
              sx={{ ml: 1, flex: 1 }}
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Box>

          {/* End Date */}
          <Box sx={{ ...filterBoxStyle, ml: "1rem" }}>
              <Typography variant="caption" sx={{ mr: 1, color: "gray" }}>
                          To:
                        </Typography>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              label="End Date"
              type="date"
              value={toDate}
              inputProps={{ min: fromDate }}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Box>

          {/* Select Service */}
          <Box sx={{ ...filterBoxStyle, ml: "2rem", width: 200 }}>
            <TextField
              select
              label="Select Service"
              size="small"
              fullWidth
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f5f5f5",
                  "& fieldset": { border: "none" },
                  "&:hover": { backgroundColor: "#e0e0e0" },
                },
                "& .MuiSelect-select": {
                  padding: "6px 12px",
                },
              }}
              SelectProps={{
                MenuProps: {
                  anchorOrigin: { vertical: "bottom", horizontal: "left" },
                  transformOrigin: { vertical: "top", horizontal: "left" },
                  getContentAnchorEl: null,
                  PaperProps: { style: { maxHeight: 200, minWidth: 200 } },
                },
              }}
            >
              {/* Placeholder MenuItem */}
              <MenuItem value="" disabled>
                Select Service
              </MenuItem>
              <MenuItem value="All">All</MenuItem>

              {serviceList?.map((service) => (
                <MenuItem key={service.srv_id} value={service.service_title}>
                  {service.service_title}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* Submit */}
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              textTransform: "capitalize",
              height: "40px",
              borderRadius: "8px",
              width: "12ch",
              backgroundColor: "#347B89",
              "&:hover": { backgroundColor: "#205964ff" },
            }}
          >
            Submit
          </Button>

          {/* Reset */}
          <Button
            variant="outlined"
            onClick={handleReset}
            sx={{
              textTransform: "capitalize",
              height: "40px",
              borderRadius: "8px",
              width: "12ch",
            }}
          >
            Reset
          </Button>
        </Stack>

        <TableContainer
          style={{ height: tableHeight }}
          // sx={{
          //   height:
          //     filteredData.length === 0 || filteredData.length < 5
          //       ? "60vh"
          //       : "default",
          // }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <OngoingServiceCard
                  style={{
                    background: "#a6b4be",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Professional Name
                    </Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Mobile No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Email</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Bank Verification{" "}
                    </Typography>
                  </CardContent>

                  <CardContent style={{ flex: 0.5 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </OngoingServiceCard>
              </TableRow>
            </TableHead>
            {loading ? (
              <Box sx={{ display: "flex", mt: 20, ml: 80, height: "130px" }}>
                <CircularProgress />
              </Box>
            ) : (
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <CardContent>
                      <Typography variant="body2">No Data Available</Typography>
                    </CardContent>
                  </TableRow>
                ) : (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          height: "3.5rem",
                        }}
                      >
                        <OngoingServiceCard
                          sx={{ display: "flex", height: "3.5rem" }}
                        >
                          <CardContent sx={{ flex: 0.5 }}>
                            <Typography variant="body2">
                              {index + 1 + page * rowsPerPage}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 2 }}>
                            <Typography variant="body2" align="center">
                              {row.professoinal_name}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 2 }}>
                            <Typography variant="body2" align="center">
                              {row.mobile_number}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 1.5 }}>
                            <Typography variant="body2" align="center">
                              {row.email_id || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent sx={{ flex: 1.5 }}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="center"
                              spacing={1}
                              sx={{
                                fontWeight: 600,
                                // Dynamic color logic
                                color:
                                  row.bank_verification === false ||
                                  row.bank_verification === "false"
                                    ? "error.main"
                                    : "success.main",
                              }}
                            >
                              {/* Icon Logic */}
                              {row.bank_verification === false ||
                              row.bank_verification === "false" ? (
                                <CancelIcon fontSize="small" />
                              ) : (
                                <CheckCircleIcon fontSize="small" />
                              )}

                              <Typography variant="body2" fontWeight="inherit">
                                {row.bank_verification === false ||
                                row.bank_verification === "false"
                                  ? "Not Verified"
                                  : "Verified"}
                              </Typography>
                            </Stack>
                          </CardContent>

                          <CardContent
                            sx={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                textTransform: "none",
                                minWidth: "60px",
                                backgroundColor: "#a6b4be",
                                "&:hover": {
                                  backgroundColor: "#8e9ea8",
                                },
                              }}
                              onClick={() => handleView(row)}
                            >
                              View
                            </Button>
                          </CardContent>
                        </OngoingServiceCard>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Modal open={openViewModal} onClose={handleCloseViewModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95%",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* APP BAR */}
            <AppBar
              position="static"
              sx={{
                backgroundColor: "#347B89",
              }}
            >
              <Stack direction="row" alignItems="center" px={2}>
                <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
                  Details Of Professional Unit
                </Typography>
                <IconButton color="inherit" onClick={handleCloseViewModal}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </AppBar>

            {/* MODAL BODY */}
            <Box sx={{ p: 3, overflowY: "auto" }}>
              <ViewPayoutDetailsmodal row={selectedRow} />
            </Box>
          </Box>
        </Modal>
      </Box>
      <Footer />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProcessPayout;
